import { Controller } from "@hotwired/stimulus"

// Generyczne przełączanie zakładek "pełnych stron" (np. /toolkit/ui/accounts).
// Wszystkie treści są w DOM od razu (lekkie), więc przełączamy tylko widoczność paneli
// i styl przycisków - bez pobierania w tle. Stan startowy ustawia HTML (na /account/menu
// na podstawie ?type= z serwera). Strona, która czyta ?type= z serwera, może włączyć
// url-param-value - wtedy przełączenie zakładki podmienia ten parametr w adresie i da się
// wysłać link do konkretnej zakładki. Rejestrowany w controllers/index.js.
export default class extends Controller {
  static targets = ["panel", "btn"]
  // nazwa parametru w adresie; puste = nie ruszamy adresu (domyślnie, np. /toolkit/ui/accounts)
  static values = { urlParam: String }

  // otwarcie na zakładce z ?tab= (np. powrót na "Pasek boczny" po zapisie), jeśli pasuje
  connect() {
    const tab = new URLSearchParams(window.location.search).get("tab")
    if (tab && this.btnTargets.some(btn => btn.dataset.tab === tab)) {
      this.activate(tab)
    }
  }

  switch(event) {
    const selected = event.currentTarget.dataset.tab
    this.activate(selected)
    this.persist(selected)
  }

  // zapisuje wybraną zakładkę w URL (?tab=), żeby odświeżenie strony ją zapamiętało
  persist(tab) {
    const url = new URL(window.location.href)
    url.searchParams.set("tab", tab)
    window.history.replaceState({}, "", url)
  }

  activate(selected) {
    this.panelTargets.forEach(panel => {
      panel.classList.toggle("hidden", panel.dataset.tab !== selected)
    })

    this.btnTargets.forEach(btn => {
      const active = btn.dataset.tab === selected
      btn.classList.toggle("text-gray-900", active)
      btn.classList.toggle("font-semibold", active)
      btn.classList.toggle("border-blue-500", active)
      btn.classList.toggle("text-gray-400", !active)
      btn.classList.toggle("font-medium", !active)
      btn.classList.toggle("border-transparent", !active)
    })

    this.updateUrl(selected)
  }

  // adres ma pokazywać aktualną zakładkę, ale bez wpisu w historii - Wstecz ma wracać
  // do poprzedniej strony, nie do poprzedniej zakładki
  updateUrl(selected) {
    if (!this.urlParamValue) return

    const url = new URL(window.location.href)
    url.searchParams.set(this.urlParamValue, selected)
    window.history.replaceState({}, "", url)
  }
}
